import { render, staticRenderFns } from "./DashboardRiskScore.vue?vue&type=template&id=65fafafa"
import script from "./DashboardRiskScore.vue?vue&type=script&lang=js"
export * from "./DashboardRiskScore.vue?vue&type=script&lang=js"
import style0 from "./DashboardRiskScore.vue?vue&type=style&index=0&id=65fafafa&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports